<template>
 <div class="modal-GR" >

    <div class="card">
        <div class="card-image">	
            <h2 class="card-heading">
                Get started
                <small>Let us create your account</small>
            </h2>
        </div>
        <form class="card-form">
            <div class="input">
                <input type="text" class="input-field" placeholder="שם הספק"  required/>
            </div>
            <div class="action">
                <button class="action-button">Get started</button>
            </div>
        </form>
        <div class="card-info">
            <a href="#" @click="closeModal">סגור</a>
      </div>
  </div>
</div>
  </template>
  
  <script>
  
  export default {
    name: 'Modal',
    data () {
      return {
        modalToggle:false
      }
    },
    methods:{
      closeModal(){
        let vm = this;
        if (vm.modalToggle) {
            vm.modalToggle = false;
        } else {
          vm.modalToggle = true;
        }
      }
    }
  }
  </script>
  
  <style>
  .modal-GR{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    min-height: 100%;
    position: fixed;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-GR .modal-box{
    min-width: 450px;
    min-height: 300px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 5px -3px rgba(255,255,255,0.2), 0 8px 10px 1px rgba(255,255,255,0.14), 0 3px 14px 2px rgba(255,255,255,0.12);
}
.modal-GR .modal-box .modal-header{
    padding: 1rem;
    border-bottom: 1px solid #e0e0e0;
    background-color: #fff;
    font-size: 16px;
    font-weight: 700;
    font-family: 'Noto Sans Hebrew';
    color: #000;
    display: flex;
    align-items: center;
}
  </style>


// WEBPACK FOOTER //
// src/components/modal.vue